import { connect } from 'react-redux'
import { selectAssignmentLabelForSelectedTickets } from 'selectors/ticket_list'
import BulkAssignmentBadge from './view'

const select = state => ({
  assignmentLabel: selectAssignmentLabelForSelectedTickets(state),
})

export default connect(select)(BulkAssignmentBadge)
